import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-download\">\n  <path fill=\"currentColor\" d=\"M11.55,7.75V4h-3v3.75h-3l4.5,4.5l4.5-4.5H11.55z M16,16H4c-0.83,0-1.5-0.67-1.5-1.5v-2.25c0-0.41,0.34-0.75,0.75-0.75 S4,11.84,4,12.25v2.25h12v-2.25c0-0.41,0.34-0.75,0.75-0.75s0.75,0.34,0.75,0.75v2.25C17.5,15.33,16.83,16,16,16z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol